import styled, { css } from 'styled-components';
import { gte } from '@lendi-ui/breakpoint';
import getColour from '@lendi-ui/commons/colours';
import Grid, { GridOptions, UnitOptions } from '@lendi-ui/grid';
import { margin, MarginOptions, ml, mr, mt, mx, my, px, py } from '@lendi-ui/spacing';
import Tabs from '@lendi-ui/tabs';
import { select } from '@lendi-ui/theme';
import { Body, body, BodyOptions, Heading } from '@lendi-ui/typography';

import { stack } from '../Stack';
import { Body as WrappedBody } from '../Typography';

export const FieldWrapper = styled.div`
  ${stack({ direction: 'column', valign: 'center' })}
  width: 100%;
`;

export interface FunnelGridProps extends GridOptions, MarginOptions {
  direction?: 'row' | 'row-reverse' | 'column' | 'column-reverse';
}
export const FunnelGrid = styled(Grid)<FunnelGridProps>`
  ${({ direction }) => direction && `flex-direction:${direction}`}
  ${margin}
`;
export interface FunnelGridUnitProps extends UnitOptions, MarginOptions {
  width?: string;
}
export const FunnelGridUnit = styled(Grid.Unit)<FunnelGridUnitProps>`
  ${({ width }) => width && `width:${width}`}
  ${margin}
`;
export const materialCard = css`
  background-color: ${() => getColour('background', 'container')};
  border-radius: ${select('borderRadius')};
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.14), 0 2px 2px 0 rgba(0, 0, 0, 0.12), 0 0 2px 0 rgba(0, 0, 0, 0.12);
`;

export const Prefix = styled(Body)`
  ${ml('xxs')};
  color: ${() => getColour('text', 'subtle')};
`;

export const Suffix = styled(Body)`
  ${mr('xxs')};
  color: ${() => getColour('text', 'subtle')};
`;

export const UppercaseBody = styled(WrappedBody)`
  text-transform: uppercase;
`;

type x = typeof Heading;

export const BoldHeading = styled(Heading)`
  font-weight: bold;
`;

export const TVSubHeading = styled(Heading)`
  font-weight: 700;
`;

export const FullWidth = styled.div`
  width: 100%;
`;

export interface FunnelBodyProps extends BodyOptions, MarginOptions {
  weight?: 'normal' | 'bold' | 'bolder' | 'lighter' | 100 | 200 | 300 | 400 | 500 | 600 | 700 | 800 | 900;
}

export const FunnelBody = styled(WrappedBody)<FunnelBodyProps>`
  ${({ weight }) => weight && `font-weight: ${weight}`}
`;

export const BaseContainer = styled.div`
  ${my('nil')}
  ${mx('auto')}
  position: relative;
`;

export const CenteredMaxWidthContainer = styled(BaseContainer)`
  max-width: 1920px;
`;

export const MainContentWrapper = styled.div`
  ${py('sm')}
  ${px({ mobile: 'xs', tablet: 'md' })}
`;

export const HeadingWrapper = styled.div`
  text-align: center;

  ${gte('sm')`
    max-width: 490px;
  `};

  ${Body} {
    ${mt('lg')}
  }
`;

export const ActionButtonsWrapper = styled.div`
  text-align: center;
  width: 100%;
  ${mt('xxl')}

  > * {
    ${gte('md')`
      width: calc(2 / 3 * 100%);
    `}

    :not(:first-child) {
      ${mt('md')}
    }
  }
`;

export const Tab = styled(Tabs.Tab)`
  font-weight: bold;
  text-transform: uppercase;
  ${px('lg')}
  ${py('xs')}
`;

export const TabContent = styled.div`
  > * {
    ${mt('md')}
  }

  > form {
    ${mt('nil')}

    & > * {
      &:first-child {
        ${mt('xs')}
      }

      &:nth-child(2) {
        ${mt('xs')}
      }
    }
  }
`;

export const Container = styled.div`
  ${stack({ halign: 'center' })}
`;

export const ContentText = styled.div`
  ${body()}
  ${mt('sm')}
  text-align: center;
`;

export const ContentWrapper = styled.div`
  ${mt('xl')}
  display: flex;
  flex-direction: column;
  width: 100%;
`;
